import data from "../../data/index.json";

import React from 'react';
import { motion } from "motion/react";

import './MySkills.css';

const gridVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

const headingVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

function SkillCard({ group }) {
  return (
    <motion.div className="skill-card" variants={cardVariants}>
      <h3 className="skill-category">{group.category}</h3>
      <ul className="skill-tags">
        {group.items.map((item) => (
          <li className="skill-tag" key={item}>
            {item}
          </li>
        ))}
      </ul>
    </motion.div>
  );
}

const MySkills = () => {
  return (
    <section className="section-page-section" id="MySkills">
      <div className="skills-list">
        <motion.h2
          variants={headingVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          My Skills
        </motion.h2>
        <motion.div
          className="skills-grid"
          variants={gridVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
        >
          {data.skills.map((group) => (
            <SkillCard key={group.category} group={group} />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default MySkills;
